export enum ContactTypeEnums {
    client = 1,
    constructionSite = 2,
    provider = 3
}
